import type { UIStringsOverride } from "../i18n-ui.ts";

/** Thai (th) UI strings. */
export const th: UIStringsOverride = {
  actions: {
    addToCursor: "เพิ่มไปยัง Cursor",
    addToVscode: "เพิ่มไปยัง VS Code",
    askAI: "ถาม AI เกี่ยวกับหน้านี้",
    connectMcp: "เชื่อมต่อกับ MCP",
    copied: "คัดลอกแล้ว!",
    copyClaudeCode: "คัดลอกคำสั่ง Claude Code",
    copyCode: "คัดลอกโค้ด",
    copyCodex: "คัดลอกคำสั่ง Codex",
    copyMarkdown: "คัดลอกเป็น Markdown",
    copyServerUrl: "คัดลอก URL ของเซิร์ฟเวอร์",
    edit: "แก้ไขบน GitHub",
    export: "ส่งออก",
    exportEpub: "ส่งออกเป็น EPUB",
    exportPdf: "ส่งออกเป็น PDF",
    generating: "กำลังสร้าง…",
    openIn: "เปิดใน {name}",
    openInChat: "เปิดในแชท",
    scrollToTop: "กลับไปด้านบน",
  },
  ask: {
    ai: "AI",
    clear: "ล้างการสนทนา",
    close: "ปิด",
    copy: "คัดลอกการสนทนา",
    empty: "ถามคำถามเกี่ยวกับเอกสาร",
    error: "ขออภัย เกิดข้อผิดพลาดบางอย่าง",
    label: "ถามคำถาม",
    placeholder: "ถามคำถาม…",
    send: "ส่ง",
    tip: "เคล็ดลับ: คุณสามารถเปิดและปิดแชทได้ด้วย",
    title: "ถาม AI",
    you: "คุณ",
  },
  banner: { dismiss: "ปิดประกาศ" },
  changelog: {
    description: "อัปเดตผลิตภัณฑ์และบันทึกประจำรุ่น",
    showReleases: "แสดงรุ่นของ {version}",
    title: "บันทึกการเปลี่ยนแปลง",
  },
  content: {
    diagramError: "ไม่สามารถแสดงไดอะแกรมนี้ได้",
  },
  feedback: {
    no: "ไม่",
    question: "หน้านี้มีประโยชน์หรือไม่?",
    thanks: "ขอบคุณสำหรับความคิดเห็นของคุณ!",
    yes: "ใช่",
  },
  languageSwitcher: { label: "ภาษา", untranslated: "ยังไม่ได้แปล" },
  nav: {
    back: "ย้อนกลับ",
    breadcrumb: "เส้นทางนำทาง",
    closeNavigation: "ปิดการนำทาง",
    deprecated: "เลิกใช้แล้ว",
    featured: "แนะนำ",
    githubRepository: "ที่เก็บ GitHub",
    navigation: "การนำทาง",
    primary: "หลัก",
    sections: "หมวด",
    toggleNavigation: "สลับการนำทาง",
    toggleTheme: "สลับธีมสี",
  },
  notFound: {
    description: "เราไม่พบหน้าที่คุณกำลังมองหา",
    home: "กลับไปหน้าแรก",
    title: "ไม่พบหน้า",
  },
  page: {
    lastUpdated: "อัปเดตล่าสุดเมื่อ",
    next: "ถัดไป",
    pagination: "การแบ่งหน้า",
    previous: "ก่อนหน้า",
    skipToContent: "ข้ามไปยังเนื้อหา",
  },
  search: {
    all: "ทั้งหมด",
    allLanguages: "ทุกภาษา",
    askAi: "ถาม AI",
    askAiHint: "รับคำตอบทันทีจาก AI",
    button: "ค้นหา",
    devOnly: "การค้นหาพร้อมใช้งานในบิลด์โปรดักชัน",
    error: "เกิดข้อผิดพลาดบางอย่าง โปรดลองอีกครั้ง",
    label: "ค้นหาเอกสาร",
    navigate: "นำทาง",
    noResults: "ไม่พบผลลัพธ์",
    open: "เปิด",
    placeholder: "ค้นหาเอกสาร…",
    popular: "ยอดนิยม",
    preview: "ดูตัวอย่าง",
    results: "ผลลัพธ์",
  },
  toc: { title: "ในหน้านี้" },
};
